import { useState } from "react";
import _ from "../../../../i18n";
import Loader from "../../../common/Loader";

import styles from "../Client.module.scss";

const List = ({
  data,
  isLoading,
  setIsFormTabActive,
  setCurrentItem,
  setCurrentDeleteItem,
  setIsOpenDeleteModal,
  toogleTypeStatus,
  isSaving,
}) => {
  const [dropDownId, setDropDownId] = useState(null);
  const toggleDropDown = (e, itemId) => {
    e.stopPropagation();
    dropDownId === itemId ? setDropDownId(null) : setDropDownId(itemId);
  };
  const getActions = (item) => {
    return (
      <div className={styles.dropDownContainer}>
        <span
          className={`${styles.cellIcon} ${
            dropDownId === item.id && styles.active
          }`}
        >
          <span
            className={`${
              dropDownId === item.id ? "icon-ttp-close" : "icon-ttp-three-dots"
            } ${styles.settingsIcon}`}
            onClick={(e) => toggleDropDown(e, item.id)}
          />
        </span>
        <ul
          className={`${styles.menuDropdown} ${
            dropDownId === item.id && styles.show
          }`}
        >
          <li
            onClick={(e) => {
              toggleDropDown(e, item.id);
              setCurrentItem(item);
              setIsFormTabActive(true);
            }}
          >
            {_("edit")}
          </li>
          {!item.isUsed && (
            <li
              onClick={(e) => {
                toggleDropDown(e, item.id);
                setCurrentDeleteItem(item);
                setIsOpenDeleteModal(true);
              }}
            >
              {_("delete")}
            </li>
          )}

          <li
            onClick={(e) => {
              toggleDropDown(e, item.id);
              toogleTypeStatus(item);
            }}
          >
            {item.status === "ENABLED" ? _("Désactiver") : _("Activer")}
          </li>
        </ul>
      </div>
    );
  };
  return (
    <div>
      <table className={`${styles.table} unstriped`}>
        <thead>
          <tr>
            <th>
              <span>{_("title")} (fr)</span>
            </th>
            <th>
              <span>{_("title")} (nl)</span>
            </th>
            <th>
              <span>{_("title")} (en)</span>
            </th>
            <th>
              <span>{_("status")}</span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {isLoading || isSaving ? (
            <tr>
              <td colSpan={7} className={styles.centerCell}>
                <Loader
                  style={{
                    height: "10px",
                  }}
                  color={"#B2BCC6"}
                />
              </td>
            </tr>
          ) : data?.data && data.data.length > 0 ? (
            data.data.map((item) => (
              <tr key={item.id}>
                <td>{item.titleFr}</td>
                <td>{item.titleNl}</td>
                <td>{item.titleEn}</td>
                <td>{item.status}</td>
                <td>{getActions(item)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className={styles.centerCell}>
                Liste vide (aucun délégation type n'a été ajouté)
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default List;
